<template lang="pug">
div

  app-modal-despacho-presidente(
    v-if="openModalDespacho && idProcesso !== null && acaoImpressao !== null",
    :idProcesso="idProcesso"
    :acao="acaoImpressao"
    :setor='"CHEFE_SETOR_DATGL"'
    :tipoProcesso="tipoProcesso"
    :tituloModalDespacho="tituloModalDespacho"
    @closeModal="openModalDespacho = false"
    @finalizar="finalizarModalDespacho"
  )
  app-modal(
    titulo='Documento',
    v-if="showModal"
    :width="1000"
    :height="800"
    @closeModal="closeModal"
  )
    template(slot="body" v-if="isMaranhao")
      div.container
        el-carousel(
          v-if="responseDocumentos"
          indicator-position='outside'
          arrow='always'
          :loop="false",
          :autoplay="false"
          @change="changeDocumentoVisualizar"
        ).body
          el-carousel-item(v-for='(item, index) in responseDocumentos' :key='index').body
            object(:data="'data:application/pdf;base64,' + item.base64" type='application/pdf' width='100%' height='100%')
        div.buttonExportPdf
          el-button(@click="downloadPdf")
            i.fal.fa-file-pdf
            span &nbsp Exportar PDF

  app-modal-visualiza-pdf(
    v-if="showModalVisualizaPdf",
    :titulo="tituloModal",
    :tipo="tipoTitulo",
    :conteudo="conteudoModal",
    :isProcesso="true",
    :imprimir="imprimirTitulo"
    @closeModal="closeModalVisualizaPdf",
  )
  app-modal-visualizar-completo(
    v-if="showModalVisualizarProcesso && idProcesso !== null",
    @closeModal="showModalVisualizarProcesso = false",
    :idProcesso="idProcesso",
    :protocolo="protocolo",
    :numeroProcesso="numeroProcesso",
    :tipo="tipoProcesso"
  )
  app-modal(
    v-if="showModalRetificarTitulo || showModalCancelarTitulo"
    @closeModal="closeModalRetificarTitulo "
    :titulo="showModalRetificarTitulo ? 'Solicitar Errata de Título' : 'Solicitar cancelamento de título'"
  )
    template(slot="body")
      el-row.margin-bottom
        span.negrito Assunto: {{assunto}} - Processo nº {{numeroProcesso}}
      validation-observer(ref='validation' tag='div')
        validation-provider(rules="required", v-slot="{ errors }")
          app-label.negrito(:label= "motivo")
          app-text-editor(
            v-model="textoDespacho"
            :class="{'erro' : errors.length}"
            :textEditable="true"
          )
          span.help-erro {{ errors[0] }}
      h4 Anexos mensagem
        app-anexo(
          :id="'upload-anexo-despacho'",
          @removeFile="removeFile",
          @uploadFile="uploadFile",
          :exibirDownload="false",
          :files="anexos",
          scope="anexos",
          v-model="anexos",
          :tipoExibir="'ANEXO_ANALISE'"
        )
    template(slot="footer")
      .flex-between
          el-button(type="secondary", @click="closeModalRetificarTitulo")
            span
              i.fa.fa-times
              span &nbsp Cancelar
          el-button(type="primary", @click="enviarSolicitacaoRetificacaoTitulo")
            span
              i.fa.fa-share-square
              span &nbsp Enviar

  el-card.card-container(shadow="hover")
    filtro(
      @pesquisar="pesquisarTitulo",
      @limpar="clearTitulo",
      :showOs="true",
      :showMunicipios="true",
      :configuracaoFiltro="configuracaoFiltro"
      :configuracaoFiltroSituacao="configuracaoFiltroSituacao"
      :showFiltroTipoMultiplo="showFiltroTipoProcessoMultiplo"
      :showFiltroDataEmissaoTitulo="showFiltroDataEmissaoTitulo",
      :showFiltroDataChegada="!isMaranhao",
      :showFiltroSetoresTituloCertidao="showFiltroSetoresTituloCertidao"
    )

  app-listagem(
    :has-refresh-button="true",
    :showButtonOrdemServico="false",
    :showButtonAssinatura="false",
    :has-expansivel="false",
    :json-headers="colunas",
    :json-data="items",
    :totalElements="totalElements",
    :pagina="filtro.pagina",
    :filtro="filtro",
    :showButtonExportarTitulos="(!isAmapa && !isMaranhao && !isBahia) ? true : false",
    textoButtonExportarTitulo="Exportar Minutas",
    caixa="TITULO_CERTIDAO"
    @atualizarFiltro="atualizarFiltro",
    @updateListagem="refreshListagem",
    @changePage="interceptChangePage",
    @sort="interceptSort",
    @executar="executar",
    @selected="false",
    @exportarCsvFiltroAnalise="exportarCsvFiltroAnalise",
    @selectItem="selectItem",
    @exportarTitulos="EXPORTAR_TITULOS"
  )
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import AppListagem from '@/components/AppListagem'
import Filtro from './FiltroWithLote'
import FILTRO_EMPTY from '@/models/filtro'
import AppModalVisualizaPdf from '../components/AppModalVisualizaPdf.vue'
import AppModalVisualizarCompleto from '@/screens/analise/components/modal/AppModalVisualizarCompleto'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import AppModal from '@/components/AppModal'
import AppTextEditor from '@/components/AppTextEditor'
import AppAnexo from '@/components/AppAnexo'
import AppLabel from '@/components/AppLabel'
import axios from '@/utils/api'
import AppModalDespachoPresidente from '../../../screens/analise/components/modal/AppModalDespachoPresidente.vue'
import acaoProcesso from '@/constants/acaoProcesso'
import statusProcesso from '@/utils/status'

const { filtro, messages } = require('@/utils/' +
  process.env.ESTADO +
  '/regrasAnalise').default
const BaseFiltro = require('./' + process.env.ESTADO + '/BaseFiltro').default
const { setoresFormatado } = require('@/utils/' + process.env.ESTADO + '/setor').default

export default {
  beforeRouteLeave (to, from, next) {
    next()
  },

  components: {
    AppListagem,
    Filtro,
    AppModalVisualizarCompleto,
    AppModalVisualizaPdf,
    AppModal,
    AppTextEditor,
    AppAnexo,
    AppLabel,
    AppModalDespachoPresidente
  },

  mixins: [BaseFiltro, AppNotificacao],

  data () {
    return {
      anexos: [],
      filtro: FILTRO_EMPTY('TITULO_CERTIDAO'),
      items: [],
      totalElements: 0,
      showModalVisualizaPdf: false,
      conteudoModal: '',
      tipoTitulo: '',
      idProcesso: null,
      numeroProcesso: null,
      tipoProcesso: null,
      protocolo: null,
      showFiltroDataEmissaoTitulo: filtro.showFiltroDataEmissaoTitulo,
      showModalVisualizarProcesso: null,
      showModalRetificarTitulo: null,
      showModalCancelarTitulo: null,
      assunto: '',
      motivo: '',
      textoDespacho: '',
      showFiltroTipoProcessoMultiplo: filtro.showFiltroTipoProcessoMultiplo,
      tituloModal: '',
      responseDocumentos: [],
      nomeDocumentoInvalido: '',
      nomeTipoDocumento: '',
      index: 0,
      acao: '',
      showModal: false,
      configuracaoFiltro: {
        filtroTitulo: filtro?.filtroTitulo?.TITULO_CERTIDAO || [],
        filtroMunicipio: filtro?.filtroMunicipio?.TITULO_CERTIDAO || [],
        filtroSituacaoTituloCertidao:
          filtro?.filtroSituacaoTituloCertidao?.TITULO_CERTIDAO || [],
        filtroOS: filtro?.filtroOS?.TITULO_CERTIDAO || []
      },
      configuracaoFiltroSituacao: {
        filtroTitulo: filtro?.filtroTitulo?.TITULO_CERTIDAO || [],
        filtroMunicipio: filtro?.filtroMunicipio?.TITULO_CERTIDAO || [],
        filtroSituacaoTituloCertidaoSituacao:
          filtro?.filtroSituacaoTituloCertidaoSituacao?.TITULO_CERTIDAO || [],
        filtroOS: filtro?.filtroOS?.TITULO_CERTIDAO || []
      },

      imprimirTitulo: false,
      openModalDespacho: false,
      isMaranhao: process.env.ESTADO === 'ma',
      isAmapa: process.env.ESTADO === 'ap',
      isBahia: process.env.ESTADO === 'ba',
      colunas: [
        {
          id: 0,
          titulo: 'Processo',
          propriedade: 'numeroProcesso',
          ordem: 1,
          acoes: [],
          type: 'icone',
          icone: 'comment-alt',
          marcado: () => !this.isAmapa && !this.isBahia
        },
        {
          id: 1,
          titulo: messages.headerTituloCertidao,
          propriedade: 'numeroTituloCertidao',
          ordem: 4,
          acoes: []
        },
        {
          id: 2,
          titulo: 'CPF/CNPJ do Interessado',
          propriedade: 'cpfCnpjInteressado',
          ordem: 2,
          acoes: []
        },
        {
          id: 3,
          titulo: 'Nome/Razão Social do Interessado',
          propriedade: 'nomeRazaoSocialInteressado',
          ordem: 2.5,
          acoes: []
        },
        {
          id: 4,
          titulo: 'Data Chegada',
          propriedade: 'dataChegadaSetor',
          ordem: 4,
          acoes: []
        },
        { id: 8,
          titulo: 'Município',
          propriedade: 'municipio',
          sortable: true,
          ordem: 3,
          acoes: [],
          exibir: () => true
        },
        {
          id: 10,
          titulo: 'Área do imóvel (ha)',
          propriedade: 'areaImovel',
          ordem: 3.5,
          acoes: [],
          exibir: () => this.isMaranhao
        },
        {
          id: 6,
          titulo: 'Tipo de Processo',
          propriedade: 'tipo',
          ordem: 5,
          acoes: []
        },
        {
          id: 7,
          titulo: 'Setor',
          propriedade: 'setor',
          ordem: 4,
          acoes: [],
          formatter: this.formataSetor,
          exibir: () => this.showColunaSituacao('filtroSituacaoTituloCertidaoSituacao')
        },
        {
          id: 9,
          titulo: 'Data de vencimento',
          propriedade: 'dataVencimento',
          ordem: 7,
          acoes: [],
          isPrazo: true,
          exibir: () => this.isMaranhao
        },
        {
          id: 7,
          titulo: 'Situação',
          propriedade: 'status',
          ordem: 10,
          acoes: [],
          exibir: () => this.showColunaSituacao('filtroSituacaoTituloCertidaoSituacao')
        },
        {
          id: 8,
          titulo: 'Ações',
          propriedade: 'tipo',
          ordem: 50, //eslint-disable-line
          acoes: [
            {
              id: 1,
              nome: 'Visualizar Processo',
              icone: 'fa-eye',
              codigo: 'VIZUALIZAR_PROCESSO',
              ordem: 1,
              show: this.showVisualizarProcesso
            },
            {
              id: 2,
              nome: 'Visualizar Certidão',
              icone: 'fa-eye',
              codigo: 'VIZUALIZAR_INFORMACAO',
              ordem: 1,
              show: this.showVisualizarCertidao
            },
            {
              id: 3,
              nome: 'Visualizar Título',
              icone: 'fa-eye',
              codigo: 'VIZUALIZAR_INFORMACAO',
              ordem: 1,
              show: this.showVisualizarTitulo
            },
            {
              id: 3,
              nome: 'Visualizar errata de título',
              icone: 'fa-eye',
              codigo: 'VIZUALIZAR_ERRATA_TITULO',
              ordem: 1,
              show: this.showVisualizarRetificacaoTitulo
            },
            {
              id: 4,
              nome: 'Acusar Entrega',
              icone: 'fa-check',
              codigo: 'ACUSAR_ENTREGA',
              ordem: 1,
              show: this.showAcusarEntrega
            },
            {
              id: 5,
              nome: 'Visualizar Ofício',
              icone: 'fa-eye',
              codigo: 'VIZUALIZAR_OFICIO',
              ordem: 1,
              show: this.showVisualizarOficio
            },
            {
              id: 5,
              nome: 'Imprimir Título',
              icone: 'fa-print',
              codigo: 'IMPRIMIR_TITULO',
              ordem: 1,
              show: this.showImprimirTitulo
            },
            {
              id: 6,
              nome: 'Solicitar errata de título',
              icone: 'fa-edit',
              codigo: 'RETIFICAR_TITULO',
              ordem: 3,
              show: this.showSolicitarRetificacaoTitulo
            }, {
              id: 7,
              nome: 'Imprimir Documentos',
              icone: 'fa-print',
              codigo: 'IMPRIMIR_DOCUMENTOS',
              ordem: 1,
              show: this.showImprimirDocumentos
            },
            {
              id: 8,
              nome: 'Retornar Setor',
              icone: 'fa-chevron-left',
              codigo: 'RETORNAR_SETOR',
              ordem: 1,
              show: this.showRetornarSetorImpressao
            },
            {
              id: 9,
              nome: 'Imprimir errata de título',
              icone: 'fa-print',
              codigo: 'IMPRIMIR_ERRATA_TITULO',
              ordem: 1,
              show: this.showImprimirRetificacaoTitulo
            },
            {
              id: 7,
              nome: 'Arquivar Título',
              icone: 'fa-chevron-left',
              codigo: 'ARQUIVAR_TITULO',
              ordem: 1,
              show: this.showRetornarArquivarImpressao
            },
            {
              id: 10,
              nome: 'Cancelar título',
              icone: 'fa-times',
              codigo: 'CANCELAR_TITULO',
              ordem: 1,
              show: this.showCancelarTitulo
            }
          ]
        }
      ],
      acaoImpressao: null,
      tituloModalDespacho: '',
      usuario: null,
      textoImprimirTituloNaoOneroso: 'Título impresso com sucesso e encaminhado para o setor Gabinete da Presidência',
      textoImprimirTituloOneroso: 'Título impresso com sucesso e encaminhado para o setor DUF',
      idsProcessosExportacao: [],
      indexDocumentoVisualidado: 0,
      showFiltroSetoresTituloCertidao: true
    }
  },

  props: {
    tipo: {
      type: String,
      required: false // trocar para true, quando tiver a props
    }
  },

  async created () {
    if (this.isMaranhao) {
      // this.filtro = this.filtraTiposProcessos(this.filtro)
      this.showFiltroSetoresTituloCertidao = false
    }
    this.loadSituacoes()
    this.usuario = await this.usuarioLogado
  },

  mounted () {
    if (this.isMaranhao) {
      this.colunas = this.colunas.filter(coluna => coluna.propriedade !== 'dataChegadaSetor')

      this.colunas.push(
        {
          id: 4,
          titulo: 'Data Emissão do Título',
          propriedade: 'dataEmissao',
          ordem: 4,
          acoes: []
        }
      )

      this.colunas.push(
        {
          id: 9,
          titulo: 'Situação',
          propriedade: 'status',
          ordem: 5,
          acoes: []
        }
      )
      this.colunas = this.colunas.sort((a, b) => a.ordem > b.ordem ? 1 : -1)
    }
  },

  watch: {
    async $route (to, from) {
      await this.init()
      if (!this.isMaranhao) {
        this.loadSituacoes()
      }
    }
  },

  computed: {
    ...mapGetters({
      usuarioLogado: 'auth/usuarioLogado'
    })
  },

  methods: {
    ...mapActions({
      exportarCsvAnalise: 'processo/exportarCsvAnalise',
      getProcessoById: 'processo/getProcessoById',
      finalizaDespachoAssinatura: 'despacho/finalizaDespachoAssinatura',
      exportarTitulosLote: 'processo/exportarTitulosLote'
    }),

    changeDocumentoVisualizar (index, oldIndex) {
      this.indexDocumentoVisualidado = index
    },

    async downloadPdf () {
      const documento = this.responseDocumentos[this.indexDocumentoVisualidado]
      const byteCharacters = atob(documento.base64)
      const byteNumbers = Array.from(byteCharacters, char => char.charCodeAt(0))
      const byteArray = new Uint8Array(byteNumbers)
      const blob = new Blob([byteArray])
      const link = document.createElement('a')
      link.href = URL.createObjectURL(blob)
      link.download = documento.nomeArquivo + '.pdf'
      link.click()
      URL.revokeObjectURL(link.href)
    },

    formataSetor (prop) {
      return setoresFormatado[prop.setor]
    },

    showColuna (coluna) {
      return (
        this.configuracaoFiltro[coluna].find(
          perfil => perfil === this.usuario?.perfilSelecionado?.codigo
        ) !== undefined
      )
    },
    showColunaSituacao (coluna) {
      return (
        this.configuracaoFiltroSituacao[coluna].find(
          perfil => perfil === this.usuario?.perfilSelecionado?.codigo
        ) !== undefined
      )
    },

    ACUSAR_ENTREGA: (_this, { item }) => {
      _this.$router.push({
        name: 'analise/analisar',
        params: {
          idProcesso: item.id,
          acaoCaixa: 'ACUSAR_ENTREGA'
        }
      })
    },

    VIZUALIZAR_INFORMACAO (_this, { item }) {
      if (item.numeroTituloCertidao !== 'Manual') {
        this.tituloModal =
          item.tipoCodigo === 'CERTIDAO_TITULO'
            ? 'Minuta da Certidão'
            : 'Minuta do Título'
        this.tipoTitulo = 'TITULO_CERTIDAO'
        this.conteudoModal = item.id
        this.showModalVisualizaPdf = true
      } else {
        this.$confirm(
          'Título/Certidão emitido fisicamente. Documento assinado eletronicamente no módulo assinador.',
          'Atenção',
          {
            type: 'warning',
            showCancelButton: false,
            confirmButtonText: 'Fechar'
          }
        ).then(() => {
          this.$emit('closeModal')
        }).catch(() => {
        })
      }
    },

    VIZUALIZAR_ERRATA_TITULO (_this, { item }) {
      if ([statusProcesso.AGUARDANDO_ASSINATURA_ERRATA_TITULO].includes(item?.codigoStatus)) {
        this.tituloModal = 'Minuta da Errata de Título'
        this.tipoTitulo = 'ERRATA_TITULO'
        this.conteudoModal = item.id
        this.showModalVisualizaPdf = true
      } else {
        this.indexDocumentoVisualidado = 0
        axios({
          method: 'POST',
          url: `publico/documentoAutenticavel/getDocumentosRetificacaoTitulo`,
          data: { idProcesso: item.id }
        }).then(resp => {
          this.responseDocumentos = resp
          this.showModal = true
        })
      }
    },

    VIZUALIZAR_OFICIO (_this, { item }) {
      this.tituloModal = 'Minuta do Ofício'
      this.tipoTitulo = 'CANCELAMENTO_CLAUSULA_RESOLUTIVA'
      this.conteudoModal = item.id
      this.showModalVisualizaPdf = true
    },

    VIZUALIZAR_PROCESSO (_this, { item }) {
      this.idProcesso = item.id
      this.numeroProcesso = item.numeroProcesso
      this.tipoProcesso = item.tipoCodigo
      this.protocolo = item.numeroProtocolo
      this.showModalVisualizarProcesso = true
    },

    RETIFICAR_TITULO (_this, { item }) {
      this.idProcesso = item.id
      this.numeroProcesso = item.numeroProcesso
      this.tipoProcesso = item.tipoCodigo
      this.protocolo = item.numeroProtocolo
      this.showModalRetificarTitulo = true
      this.assunto = 'Solicitar Errata de Título'
      this.motivo = 'Especifique o motivo da errata de título:'
    },
    async CANCELAR_TITULO (_this, { item }) {
      this.idProcesso = item.id
      this.numeroProcesso = item.numeroProcesso
      this.tipoProcesso = item.tipoCodigo
      this.protocolo = item.numeroProtocolo
      this.showModalCancelarTitulo = true
      this.assunto = 'Solicitar cancelamento de título'
      this.motivo = 'Especifíque o motivo do cancelamento de título'
    },

    async IMPRIMIR_TITULO (_this, { item }) {
      this.confirmBox(this.$messages.CONFIRMAR_IMPRIMIR_TITULO, this.$messages.TITULO_WARNING, () => {
        _this.executarTramitacaoImpressaoTitulo({idProcesso: item.id, acao: this.retornaAcao(item)}).then(async (setorDestino) => {
          this.notificacaoImprimirTitulo(acaoProcesso.FINALIZAR, setorDestino)
          axios({
            method: 'POST',
            url: `publico/documentoAutenticavel/getDocumentosTitulo`,
            data: { idProcesso: item.id }
          }).then(resp => {
            this.responseDocumentos = resp
            this.showModal = true
          })
          await this.refreshListagem()
        }).catch((err) => {
          this.showNotificacao(this.$messages.TIPO_WARNING, this.$messages.TITULO_WARNING,
            'Houve um problema ao tentar imprimir o PDF, tente novamente mais tarde.')
          console.error(err)
        })
      })
      return false
    },
    async IMPRIMIR_ERRATA_TITULO (_this, { item }) {
      this.confirmBox(this.$messages.CONFIRMAR_IMPRIMIR_ERRATA_TITULO, this.$messages.TITULO_WARNING, () => {
        _this.executarTramitacaoImpressaoTitulo({idProcesso: item.id, acao: 'TITULO_COM_ERRATA.CHEFE_SETOR.DATGL.AUTOCOMPLETE'}).then(async (resp) => {
          this.notificacaoImprimirTitulo(acaoProcesso.EMITIR_ERRATA_TITULO, 'DATGL')
          axios({
            method: 'POST',
            url: `publico/documentoAutenticavel/getDocumentosRetificacaoTitulo`,
            data: { idProcesso: item.id }
          }).then(resp => {
            this.responseDocumentos = resp
            this.showModal = true
          })
          await this.refreshListagem()
        }).catch((err) => {
          this.showNotificacao(this.$messages.TIPO_WARNING, this.$messages.TITULO_WARNING,
            'Houve um problema ao tentar imprimir o PDF, tente novamente mais tarde.')
          console.error(err)
        })
      })
      return false
    },
    IMPRIMIR_DOCUMENTOS (_this, { item }) {
      axios({
        method: 'POST',
        url: `documento/pdfViewByIdDocumentos`,
        data: { idProcesso: item.id }
      }).then(resp => {
        const { documentosValidos, documentosInvalidos } = this.retirarDocumentosInvalidos(resp)
        if (documentosValidos.length > 0) {
          if (documentosInvalidos.length > 0) {
            this.notificaDocumentoInvalido()
            this.responseDocumentos = documentosValidos
            this.showModal = true
          }
          this.responseDocumentos = documentosValidos
          this.showModal = true
        } else {
          this.showNotificacao(this.$messages.TIPO_WARNING, this.$messages.TITULO_WARNING,
            'Atenção! Nenhum dos documentos estão compatíveis para impressão.')
        }
      }).catch((err) => {
        this.showNotificacao(this.$messages.TIPO_WARNING, this.$messages.TITULO_WARNING,
          'Nenhum documento foi encontrado no processo.')
        console.error(err)
      })
      return false
    },
    EXPORTAR_TITULOS () {
      this.confirmBox(
        `Ao confirmar, as minutas dos processos selecionados serão processadas. Processos que não contêm minutas serão ignorados.`,
        'Atenção', () => {
          const config = this.idsProcessosExportacao.length ? {
            mensagem: 'As minutas estão sendo processadas e o download começará automaticamente ao término. Processos que não contêm minutas serão ignorados.',
            tipo: 'Sucesso',
            acoes: { confirmButtonText: 'Ok', type: 'success' }
          } : {
            mensagem: 'Não foi identificado nenhum processo selecionado. Por favor, selecione os processos e tente novamente.',
            tipo: 'Alerta',
            acoes: { confirmButtonText: 'Ok', type: 'warning' }
          }

          if (this.idsProcessosExportacao.length) {
            this.exportarTitulosLote(this.idsProcessosExportacao)
          }

          this.$alert(config.mensagem, config.tipo, config.acoes)
        },
        () => {}
      )
    },
    RETORNAR_SETOR (_this, {item}) {
      this.idProcesso = item.id
      this.acaoImpressao = item.tipoCodigo === 'REURB_INDIVIDUAL' ? 'RETORNO.SISTEMA.DATGL_TITULO' : 'RETORNO.SISTEMA.ANTERIOR'
      this.openModalDespacho = true
      this.tituloModalDespacho = 'Retornar Setor'
    },
    ARQUIVAR_TITULO (_this, {item}) {
      this.idProcesso = item.id
      this.acaoImpressao = 'SOLICITAR_ARQUIVAMENTO.CHEFE_SETOR.COMISSAO_ILHA.AUTOCOMPLETE'
      this.openModalDespacho = true
      this.tituloModalDespacho = 'Arquivar Título'
      this.tipoProcesso = item.tipoCodigo
    },
    async finalizarModalDespacho (despacho) {
      let isRetorno = this.acaoImpressao.includes(acaoProcesso.RETORNO)
      this.$confirm(
        isRetorno ? 'Tem certeza que deseja retornar setor?' : 'Tem certeza que deseja arquivar o título?',
        {
          confirmButtonText: 'Confirmar',
          cancelButtonText: 'Cancelar',
          type: 'warning'
        }
      )
        .then(async () => {
          if (isRetorno) {
            axios({
              method: 'DELETE',
              url: `despacho/deleteTitulo/${this.idProcesso}`
            }).then(async () => {
              await this.executarTramitacaoImpressaoTitulo(despacho, null)
              this.refresh()
              this.setOpenModal(false)
              this.notificacaoImprimirTitulo(acaoProcesso.RETORNO)
            })
              .catch(() => {
              })
          } else {
            await this.executarTramitacaoImpressaoTitulo(despacho, null)
            this.refresh()
            this.setOpenModal(false)
            this.notificacaoImprimirTitulo(acaoProcesso.SOLICITAR_ARQUIVAMENTO)
          }
        })
    },
    notificacaoImprimirTitulo (decisao, setorDestino) {
      const mensagem = {
        FINALIZAR: 'Título impresso com sucesso e encaminhado para o setor ' + setorDestino,
        RETORNO: 'Retornado para emissão de título!',
        SOLICITAR_ARQUIVAMENTO: 'Processo encaminhado para o arquivamento.',
        EMITIR_ERRATA_TITULO: 'Errata impressa com sucesso. Processo enviado para o setor DATGL.'
      }
      return this.showNotificacao(this.$messages.TIPO_SUCCESS, this.$messages.TITULO_SUCCESS,
        mensagem[decisao])
    },
    loadSituacoes () {
      if (this.items.length > 0) {
        this.items.forEach(processo => {
          switch (processo.codigoStatus) {
            case 'AGUARDANDO_ENTREGA':
              processo.status = 'Aguardando Entrega'
              break
            case 'AGUARDANDO_ASSINATURA':
              processo.status = 'Aguardando Assinatura'
              break
            case 'FINALIZADO':
              processo.status = 'Finalizado'
              break
            default:
              processo.status = 'Entregue'
          }
        })
      }
    },
    async selectItem (item) {
      item.selecionado = !item.selecionado
      if (item.selecionado) {
        const existe = this.idsProcessosExportacao.find(i => i === item.id)
        if (!existe) {
          this.idsProcessosExportacao.push(item.id)
        }
      } else {
        this.idsProcessosExportacao = this.idsProcessosExportacao.filter(i => i !== item.id)
      }
      await this.atualizarListagem()
    },

    async atualizarListagem () {
      const itemsAux = [...this.items]
      this.items = []
      this.items = [...itemsAux]
    },

    async refreshListagem () {
      this.items = []
      this.idsProcessosExportacao = []
      await this.refresh()
      if (!this.isMaranhao) {
        this.loadSituacoes()
      }
    },
    async pesquisarTitulo (filtro) {
      if (this.isMaranhao) {
        // filtro = this.filtraTiposProcessos(filtro)
      }
      await this.pesquisar(filtro)
      if (!this.isMaranhao) {
        this.loadSituacoes()
      }
    },
    async clearTitulo () {
      await this.clear()
      if (!this.isMaranhao) {
        this.loadSituacoes()
      } else {
        // this.filtro = this.filtraTiposProcessos(this.filtro)
        await this.pesquisar(this.filtro)
      }
    },
    closeModalVisualizaPdf () {
      this.showModalVisualizaPdf = false
      this.imprimirTitulo = false
    },
    atualizarFiltro (novoFiltro) {
      this.filtro = {
        ...this.filtro,
        ...novoFiltro
      }
      this.filtroRapido = novoFiltro
    },

    async exportarCsvFiltroAnalise () {
      await this.filtroComColunasExibidas()
      this.exportarCsvAnalise(this.filtro)
    },
    filtraTiposProcessos (filtro) {
      return {
        ...filtro,
        tipos: !filtro?.tipos?.length ? ['NAO_ONEROSO', 'ONEROSO', 'PEAS', 'REURB_COLETIVO', 'TQ', 'NAO_ONEROSO_FISICO', 'ONEROSO_FISICO'] : filtro?.tipos
      }
    },

    closeModalRetificarTitulo () {
      this.showModalRetificarTitulo = false
      this.showModalCancelarTitulo = false
      this.textoDespacho = ''
      this.anexos = []
    },

    async uploadFile (file) {
      this.anexos.push({
        key: file.response,
        nome: file.name,
        tipo: {
          id: 51,
          codigo: 'ANEXO_ANALISE'
        }
      })
    },

    removeFile (file) {
      const index = this.anexos.findIndex(obj => obj === file)
      this.anexos.splice(index, 1)
    },

    async enviarSolicitacaoRetificacaoTitulo () {
      const valido = await this.$refs.validation.validate()
      if (!valido) {
        this.showNotificacao(this.$messages.TIPO_WARNING, this.$messages.TITULO_WARNING, this.$messages.CAMPO_OBRIGATORIO)
        return
      }
      if (this.showModalRetificarTitulo) {
        this.confirmBox(
          this.$messages.CONFIRM_ERRATA_TITULO,
          this.$messages.TITULO_WARNING,
          async () => {
            try {
              const processo = await this.getProcessoById(this.idProcesso)
              await axios({
                method: 'post',
                data: {
                  processo,
                  textoDespacho: this.textoDespacho,
                  anexos: this.anexos,
                  acao: 'SOLICITAR_ERRATA_TITULO.CHEFE_SETOR.DATGL_ERRATA_TITULO.AUTOCOMPLETE'
                },
                url: 'processo/retificarTitulo',
                error: true
              }).then(response => {
                this.showNotificacao(
                  this.$messages.TIPO_SUCCESS,
                  this.$messages.TITULO_SUCCESS,
                  this.$messages.SUCESSO_SOLICITAR_ERRATA_TITULO
                )
                this.textoDespacho = ''
                this.refreshListagem()
              })
            } catch (error) {
              this.showNotificacao(
                this.$messages.TIPO_ERROR,
                this.$messages.TITULO_ERROR,
                this.$messages.ERRO_SOLICITAR_ERRATA_TITULO
              )
            } finally {
              this.closeModalRetificarTitulo()
            }
          },
          () => {
            //
          }
        )
      } else {
        this.confirmBox(
          this.$messages.CONFIRM_CANCELA_TITULO,
          this.$messages.TITULO_WARNING,
          async () => {
            try {
              const processo = await this.getProcessoById(this.idProcesso)
              await axios({
                method: 'post',
                data: {
                  processo,
                  textoDespacho: this.textoDespacho,
                  anexos: this.anexos,
                  acao: 'SUB_FLUXO_GESTAO_SICARF_CANCELAMENTO_TITULO_' + processo.tipo.codigo
                },
                url: 'processo/cancelarTitulo',
                error: true
              }).then(response => {
                this.showNotificacao(
                  this.$messages.TIPO_SUCCESS,
                  this.$messages.TITULO_SUCCESS,
                  this.$messages.SUCESSO_SOLICITAR_CANCELA_TITULO
                )
                this.textoDespacho = ''
                this.refreshListagem()
              })
            } catch (error) {
              this.showNotificacao(
                this.$messages.TIPO_ERROR,
                this.$messages.TITULO_ERROR,
                this.$messages.ERRO_SOLICITAR_CANCELA_TITULO
              )
            } finally {
              this.closeModalRetificarTitulo()
            }
          },
          () => {
            //
          }
        )
      }
    },
    closeModal () {
      this.showModal = false
      this.refreshListagem()
    },
    retirarDocumentosInvalidos (documento) {
      const documentosValidos = documento.filter(doc => doc.nome && doc.nome.toLowerCase().endsWith('.pdf'))
      const documentosInvalidos = documento.filter(doc => doc.nome && !doc.nome.toLowerCase().endsWith('.pdf'))

      if (documentosInvalidos.length > 0) {
        this.nomeTipoDocumento = documentosInvalidos[0].codigoDocumento
        this.nomeDocumentoInvalido = documentosInvalidos[0].nome
      } else {
        this.nomeDocumentoInvalido = ''
      }

      return { documentosValidos, documentosInvalidos }
    },
    notificaDocumentoInvalido () {
      this.showNotificacao(this.$messages.TIPO_WARNING, this.$messages.TITULO_WARNING,
        `Há documento(s) não compatível(eis) para impressão`)
    },
    setOpenModal (openModal) {
      this.openModalDespacho = openModal
    },
    interceptChangePage (prop) {
      this.idsProcessosExportacao = []
      this.changePage(prop)
    },
    interceptSort (prop) {
      this.idsProcessosExportacao = []
      this.sort(prop)
    },
    isEstadoMa () {
      return process.env.ESTADO === 'ma'
    },
    retornaAcao (processo) {
      // TODO: Após desocultar perfil GESTÃO SICARF, trocar o retorno pelo abaixo, afim de evitar quebrar possíveis futuras implementações do reurb individual em, outros estados
      // return this.usuario.moduloSelecionado.codigo !== 'GESTAO_SICARF' ? 'FINALIZAR.DATGL.IMPRESSAO.AUTOCOMPLETE' : 'FINALIZAR.GESTAO_SICARF.IMPRESSAO.AUTOCOMPLETE'
      return (this.usuario.moduloSelecionado.codigo === 'GESTAO_SICARF' || processo.tipoCodigo === 'REURB_INDIVIDUAL') ? 'FINALIZAR.GESTAO_SICARF.IMPRESSAO.AUTOCOMPLETE' : 'FINALIZAR.DATGL.IMPRESSAO.AUTOCOMPLETE'
    }
  }
}
</script>
<style lang="scss" scoped>
.card-container {
  margin: 20px;
  border-radius: 10px;
}
.margin-bottom {
  margin-bottom: 20px;
}
.negrito {
  color: #000;
  font-weight: bold;
}
.flex-between {
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: space-between;
}
.help-erro {
  color: red;
  margin-left: 5px;
  font-size: 12px;
}
.body {
  height: 600px !important;

  @media (min-height: 425px) and (max-height: 767px) {
    height: 450px !important;
  }

  @media (min-height: 768px) and (max-height: 768px) {
    height: 450px !important;
  }

  @media (min-height: 769px) and (max-height: 1365px) {
    height: 550px !important;
  }

  @media (min-height: 1366px) {
    height: 600px !important;
  }
}
.container {
  position: relative;
  height: 100%;
}
.buttonExportPdf {
  position: absolute;
  bottom: -20px;
  right: 0;
  z-index: 9999;
}
</style>



// WEBPACK FOOTER //
// src/screens/analise/listagem/CaixaTitulosECertidoesListagem.vue